export default "__VITE_ASSET__HJNocQV5__"